import { Box } from "@mui/material";
import StyledDataGrid from "../../../../components/StyledDataGrid";
import { getPrettyDate, useLocalTime } from "../../../../utils/timestamp";
import AdminChip from "./AdminChip";

const UserAdminPermissionsTable = ({ adminPermissions, gridRef }) => {
  const rowsWithId = (adminPermissions || []).map((permission, index) => ({
    ...permission,
    id: permission.id || index,
  }));
  const showLocalTime = useLocalTime();
  const tableColumns = [
    {
      headerName: "Admin Permissions",
      field: "admin_type",
      flex: 1.3,

      renderCell: (params) => {
        return (
          <Box style={{ whiteSpace: "nowrap" }}>
            <AdminChip
              permissionType={params?.value}
              withLabel={true}
              category={params.row?.admin_category}
            />
          </Box>
        );
      },
    },
    {
      headerName: "First Seen",
      field: "first_seen",
      flex: 0.5,
      align: "left",
      valueFormatter: (params) =>
        getPrettyDate(params?.value?.timestamp_utc, showLocalTime),
      renderCell: (params) => (
        <Box style={{ whiteSpace: "nowrap" }}>
          {getPrettyDate(params?.value?.timestamp_utc, showLocalTime)}
        </Box>
      ),
    },
    {
      headerName: "Last Seen",
      field: "last_seen",
      flex: 0.5,
      align: "left",
      headerAlign: "left",
      valueFormatter: (params) =>
        getPrettyDate(params?.value?.timestamp_utc, showLocalTime),
      renderCell: (params) => (
        <Box style={{ whiteSpace: "nowrap" }}>
          {getPrettyDate(params?.value?.timestamp_utc, showLocalTime)}
        </Box>
      ),
    },
  ];
  return (
    <StyledDataGrid
      style={{ cursor: "pointer" }}
      columns={tableColumns}
      rows={rowsWithId}
      apiRef={gridRef}
      pageSizeOptionsOverride={[10, 15, 20]}
      checkboxSelection={false}
      rowHeight={"24px"}
      selectionModel={[]}
    />
  );
};

export default UserAdminPermissionsTable;
